/* eslint-disable */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
;// CONCATENATED MODULE: ./src/packages/water-mark/useWatermarkBg.js

function useWatermarkBg(props) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.computed)(() => {
    // 创建一个 canvas
    const canvas = document.createElement('canvas');
    const devicePixelRatio = window.devicePixelRatio || 1;
    // 设置字体大小
    const fontSize = props.waterFontSize * devicePixelRatio;
    const font = fontSize + 'px ' + props.waterFontFamily;
    const ctx = canvas.getContext('2d');
    // 获取文字宽度
    ctx.font = font;
    const {
      width
    } = ctx.measureText(props.waterName);
    const canvasSize = Math.max(100, width) + props.waterGap * devicePixelRatio;
    canvas.width = canvasSize;
    canvas.height = canvasSize;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    // 旋转 45 度让文字变倾斜
    ctx.rotate(Math.PI / 180 * -props.waterRotate);
    ctx.fillStyle = props.waterFontColor;
    ctx.font = font;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // 将文字画出来
    ctx.fillText(props.waterName, 0, 0);
    return {
      base64: canvas.toDataURL(),
      size: canvasSize,
      styleSize: canvasSize / devicePixelRatio
    };
  });
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/packages/water-mark/index.vue?vue&type=script&setup=true&lang=js



const __default__ = {
  name: 'watermark'
};
/* harmony default export */ var water_markvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  props: {
    waterName: {
      // 传入水印的文本
      type: String,
      required: true,
      default: "watermark"
    },
    waterFontSize: {
      // 字体的大小
      type: Number,
      default: 14
    },
    waterGap: {
      // 水印重复的间隔
      type: Number,
      default: 20
    },
    waterRotate: {
      // 水印倾斜
      type: Number,
      default: 45
    },
    waterFontFamily: {
      // 水印字体
      type: String,
      default: "Microsoft Yahei"
    },
    waterFontColor: {
      // 水印字体颜色
      type: String,
      default: "rgba(0, 0, 0, 0.3)"
    }
  },
  setup(__props) {
    const props = __props;
    const watermarkContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(null); // 挂载的dom节点
    const div = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(null); // 水印节点
    const k = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.ref)(null); // 监听器
    const bg = useWatermarkBg(props); // 水印参数
    const {
      base64,
      styleSize
    } = bg.value;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.onMounted)(() => {
      addDom();

      // 添加dom监控器
      k.value = new MutationObserver(records => {
        for (const record of records) {
          for (const dom of record.removedNodes) {
            if (dom === div.value) {
              div.value.remove();
              addDom();
              return;
            }
          }
          if (record.target === div.value) {
            div.value.remove();
            addDom();
            return;
          }
        }
      });
      k.value.observe(watermarkContainer.value, {
        childList: true,
        attributes: true,
        subtree: true
      });
    });
    const addDom = () => {
      div.value = document.createElement("div");
      div.value.style.backgroundImage = `url(${base64})`;
      div.value.style.inset = 0;
      div.value.style.zIndex = 9999;
      div.value.style.position = "absolute";
      div.value.style.backgroundRepeat = "repeat";
      div.value.style.backgroundSize = `${styleSize}px ${styleSize}px`;
      div.value.style.pointerEvents = "none";
      watermarkContainer.value.appendChild(div.value);
    };
    return (_ctx, _cache) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
        class: "watermark-container",
        ref_key: "watermarkContainer",
        ref: watermarkContainer
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderSlot)(_ctx.$slots, "default")], 512);
    };
  }
}));
;// CONCATENATED MODULE: ./src/packages/water-mark/index.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./src/packages/water-mark/index.vue



const __exports__ = water_markvue_type_script_setup_true_lang_js;

/* harmony default export */ var water_mark = (__exports__);
;// CONCATENATED MODULE: ./src/packages/index.js

const components = [water_mark];

// 注册组件
const install = function (Vue) {
  components.forEach(k => {
    Vue.component(k.name, k);
  });
};
/* harmony default export */ var src_packages = (install);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (src_packages);


module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=watermark.common.js.map